import type { ComponentProps } from "react";
import { Platform } from "react-native";
import * as DropdownMenu from "zeego/dropdown-menu";
import { Space } from "~/constants/sizing";

export const DropdownItem = DropdownMenu.create(
    ({ style, ...itemProps }: ComponentProps<typeof DropdownMenu.Item>) => (
        <DropdownMenu.Item
            {...itemProps}
            style={{
                height: 44,
                paddingLeft: 16,
                paddingRight: 16,
                paddingTop: 12,
                paddingBottom: 12,
                ...Platform.select({
                    web: {
                        display: "flex",
                        flexDirection: "row",
                        gap: Space.xs,
                        alignItems: "center",
                    },
                }),
                ...style,
            }}
        />
    ),
    "Item",
);
